<template>



  <div style="display:flex; margin-top:16px" class="mb-10 nodetype" >

   
    <b-col>
     
<div style="border-top-right-radius: 15px">
   
 
  <div  style="min-height: 38px; font-size:16px;background-color:#008380 ; display:flex; justify-content: center; color:white; text-align: center;  border-top-right-radius: 12px !important;border-top-left-radius: 12px !important; padding-bottom: 10px;position: relative; padding: 0.486rem 1rem;" :style="data.md ? { 'width':'400px'} : { 'width': '300px'}">
    <div style="padding-right: 30px;">
      {{  (data.node_name).toUpperCase() }} 
    </div>
  
    
   
  <!----
  <div style="postion:absolute !important;left:0">
    <b-button
              class="burbuja"
            
            
            >
            1
            </b-button>
  </div>-->
  <div style="position: absolute; background-color: transparent; color: white;  width: 50px;right: 0px; top:3px">
    <div
          style="text-align: center; width:100%;cursor: pointer;;"
        >
          <feather-icon
            icon="TrashIcon"
            size="16"
            class="close-btn delSlide"
            @click="remove_popup(data.id)"
         
          /></div>
  </div>

  </div>
  
  <div style=" min-height: 270px; background-color: #e8eaee ;   border-radius: 12px; padding-bottom:10px" :style="data.md ? { 'width':'400px'} : { 'width': '300px'}">
    <div style ="min-height:50px ; font-size:12px; text-align: left; " >
      <div  style="height: 30px; padding:0 !important; display: flex; justify-content: space-between;; top:0 !important; font-size:12px;background-color:#909090 ; color:white; text-align: left; padding-bottom: 10px; padding: 0.486rem 1rem;border-radius" :style="data.md ? { 'width':'400px'} : { 'width': '300px'}">
        <div>
          Total cells
        </div>
        <div>
          {{  (data.total_cells).toLocaleString("es-ES")}} 
        
        </div>
       
     
      </div>
      
       
      <div style="margin: 0.486rem 1rem !important; font-size:10px;">
        <div style="display:inline-block">
          <div >
            <b-form-checkbox
                    v-model="do_norm"
                    class="custom-control-secondary"
                    style="font-size:10px !important"
                    :disabled="data.comp_norm != 0"
                    @change="update_node_settings()"
            > 
             Do Normalization 
            </b-form-checkbox>

          </div>
          <div >
            <b-form-checkbox
                    v-model="do_samp"
                    class="custom-control-secondary"
                    :disabled="data.comp_norm != 0"
                    @change="update_node_settings()"
            > 
             Do Sampling 
            </b-form-checkbox>
          </div>
         
      </div>
        <div style="margin-top:10px;font-size:10px">
          Cells:
          
          <b-form-spinbutton-input
            :state="false"
            style="margin-top:5px"
            id="80"
            v-model="number_cells"
            :disabled="data.comp_norm != 0"
            :readonly="false"
            :min="1"
            :max="1000000"
            :width="140"
            size="sm"
            @click="update_node_settings()"
   
          />

        </div>
      
      </div>
        <div style="margin: 0.486rem 1rem !important;">
          <strong> {{  description() }}</strong> 
          <div style="color:grey;font-size:10px;">
            {{  showTime(data.timestamp) }}
          </div>

        </div>
      
      
    </div>
    <div style ="min-height:60px ; background-color: white; margin-top: 5px; font-size: 12px; margin: 0.486rem 1rem !important; text-align: left;">
      <b-badge
          v-for="(marker, index) in clusters_sel"
          :key="index"
          class="m-50"
          :variant="'light-info'"
        >
          {{ marker }}
        </b-badge>
     
    </div>
   
    <div style ="margin-top:10px; margin: 0.486rem 1rem !important;">
      <v-select
        v-model="actionClicked"
        :options="getOptions()"
        placeholder="Select an option"
        :searchable="true"
        style="width: 100%; margin-right:3px; background-color: white; font-size:13px; "
      />
    </div>
  

  </div>
</div>

</b-col>




 
  

</div>
</template>
<script>
import Vue from 'vue'
import { BButton,  BFormInput, BFormGroup, BRow, BCol, BFormCheckbox, BBadge } from 'bootstrap-vue'
import InputColorPicker from 'vue-native-color-picker'
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import store from '@/store/index'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import MarkerList from '../markerList.vue'
import BFormSpinbuttonInput from '@core/components/b-form-spinbutton-input/BFormSpinbuttonInput.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ToggleButton } from 'vue-js-toggle-button'
import Swal from 'sweetalert2'
import vSelect from 'vue-select'

const { url, port, auth } = store.state.appConfig.api
const headers = {
authentication: auth,
'Content-Type': 'application/json',
}

export default {
components: {
BFormInput,
MarkerList,
BBadge,
vSelect,
BFormGroup,
BRow,
BFormSpinbuttonInput,
BCol,
InputColorPicker,
VueRangeSlider,
BButton,
Loading,
ToggleButton,
BFormCheckbox,

},
props: {
  parent_version:{
  required: true,
      type: Array,
      default: () => [],
},

data: {
  required: true,
  type: [Object, String],
  default: 0,
},
allow_data:{
  required:true,
  type: Boolean,
  default:true
}




},
data() {
return {
  actionClicked:'',
  clusters_sel: [],
  node_description: '',
  show_marker_list: false,
  do_actions: ['Calculate total cells','Do sampling and normalization', 'Annotation tool'],
  isLoadingInfo: true,
  isLoading: false,
  max_width_v: '400px',
  number_cells:25000,
  do_norm:true,
  do_samp:true,
  
 

}
},
created() {

this.clusters_sel = []
var a = this.data.clusters
try{
  a = a.split(",")
  
}
catch (e){
  a = []
}
this.clusters_sel = a;



if(this.data.md == false){
  this.max_width_v = '400px'

}
this.description()
this.number_cells = this.data.number_cells
if(this.data.do_norm == 0){
  this.do_norm = false
}
if(this.data.do_sampling == 0){
  this.do_samp = false
}


},



methods: {
  update_node_settings(){
    console.log("Change norm", this.do_norm, "samplign", this.do_samp, "cells", this.number_cells)
    const { do_norm, do_samp, number_cells } = this
    var do_norm_int = 1
    var do_samp_int = 1
    if(!do_norm){ do_norm_int = 0}
    if(!do_samp){ do_samp_int = 0}
    const data = { do_norm: do_norm_int, do_samp: do_samp_int, number_cells: number_cells}
    const node_id = this.data.id
    console.log("NODE ID IS", node_id, "DATA", data)
  axios.put(`${url}:${port}/downstream-update-node/${node_id}`, JSON.stringify(data), { headers }).then(result => {
  
    console.log(result)
  })

  },
  showTime(time){
    
    
    if(this.data.comp_cell == 1 || ( this.data.comp_norm == 1)){
      if(time == null || time == undefined){
        return ' In queue'
      }
     
    }
   
    
    return time


  },
getOptions(){

  if(this.data.comp_cell == 0){
   return ['Calculate total cells']
  }
  else if(this.data.comp_norm == 2){
    return ['Annotation tool']
   
  }
  else if(this.data.comp_cell == 1){
    return []
  }
  else if(this.data.comp_cell == 2 && this.data.total_cells == 0){
      return []
  }
  else if(this.data.comp_cell == 2 && this.data.comp_norm == 0){
    return ['Do sampling and normalization']
  }
  else if(this.data.comp_norm == 2){
    return ['Do sampling and normalization']
  }
 
  
},
description(){
  var strSend = ''
  
  if(this.data.comp_cell == 0){
    strSend = 'Pending to calculate Cells'
   
  }
  else if(this.data.comp_cell == 1){
    strSend = 'Calculating cells ...'
  }
  else if(this.data.comp_cell == 2 && this.data.total_cells == 0){
    strSend =  'Sorry, not enough cells to continue'
  }
  else if(this.data.comp_cell == 2 && this.data.comp_norm == 0){
    strSend = 'Pending to do normalization'
  }
  else if(this.data.comp_norm == 1){
    strSend = ' Doing normalization.. step ' + this.data.norm_process + '/3'
  }
  else if(this.data.comp_norm == 2){
    strSend = 'Versions available'
  }
  this.node_description = strSend;
  return strSend
     
},
show_markerSelection(){


const node_id = this.data.id
const project_id = Number(this.$route.params.id)

const markerLists = new Vue({
  ...MarkerList,

  propsData: { selected: false, preprocess: true, status: {}, node_id: node_id, project_id: project_id, parent_version_id: this.parent_version},
}).$mount()
this.$swal({
  html: markerLists.$el,
  showCloseButton: true,
  showCancelButton: false,
  showConfirmButton: false,
  confirmButtonText: 'Save',
  width: '95%',
  


}).then(async result => {
  
   // this.$swal.clearData()
  console.log("MAITE CLOSE",result)

    if (result.dismiss == 'close' || result.dismiss == 'esc') {
      markerLists.unMount()
      
    }
  })
},
showSettingWarning(){
      var warning_info = 'Please, select a server and choose a project/experimental folder to continue.'
      this.$swal({
        title: 'Missing configuration',
        text: warning_info,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          return false
        }
      })
    },
delNode(node_id){
  console.log("Remove node", node_id)
  axios.post(`${url}:${port}/downstream-node/${node_id}`, { }, { headers }).then(result => {
     location.reload()
    
  })
  },
  remove_popup(id){
    
    this.$swal({
      title: 'Are you sure?',
      text: "Selected node will be deleted. You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'YES',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        this.delNode(id)
      }
    })

  },
actionClickedjj(value){
},
calculate_cells(){
  console.log("Calculate cells")
  const { id } = this.$route.params
  const node_id = this.data.id
  axios.post(`${url}:${port}/downstream-cells/${id}/${node_id}`, { }, { headers }).then(result => {
   
    console.log(result)
  })


},
preprocess(force = false) {

  this.version = null
  const { id } = this.$route.params
  const node_id = this.data.id
  axios.post(`${url}:${port}/downstream-preprocess/${id}/${node_id}`, { user: 1, force }, { headers }).then(result => {
    this.downstream_computing = true
    this.downstream_tmp_computing = true
    console.log(result)
  })

},







},
watch:{
  number_cells: function(value){
    this.update_node_settings()
  },
/*'data.comp_cell': function(value){
  this.description()

},
'data.comp_norm': function(value){
  this.description()

},
'data.norm_process': function(value){
  this.description()

},*/
actionClicked: function(value){
 /* if(this.allow_data == false){
    this.showSettingWarning()
    return
  }*/
  if(value == 'Calculate total cells'){
    this.calculate_cells()

  }
  if(value == 'Do sampling and normalization'){
    this.preprocess()

  }
  if(value == 'Annotation tool'){
    this.show_markerSelection()
    

  }
  this.actionClicked = ''
}
}
}
</script>
<style>
.nodetype .icp__input {
height: 20px!important;
width: 28px!important;
margin-right:10px;
}
.nodetype .custom-checkbox .custom-control-label{
  font-size: 0.857rem;
}
.swal2-actions{
margin: 0 10px;
/* display: none !important;  */
}
.nodetype .vue-range-slider.slider-component {
margin-left:0px!important;
}
.sat_slider{
margin-top: -30px!important;
margin-bottom: 20px!important;
}
#new-paint .swal2-confirm swal2-styled{
/* display: none; */

}
.nodetype .vs__selected{
  color:white !important;
}
/* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
background-color: dodgerblue !important;
} */

</style>
<style scoped>
.burbuja{
  background-color: transparent !important;
  border:0;
  z-index: 5834059354;
  font-size: 12px;
    padding: 0 !important;
    position: absolute !important;
    background-color: #F3C13A !important;
    height: 30px !important;
    width: 30px !important;
    left:2px;
    /* margin-bottom: 15px; */
    /* padding-bottom: 15px; */
    top: -10px;
    color: black;
    color: black !important;
    border-radius: 50%;
    border: 1px solid grey;
}
h4{
display: flex;
align-items: flex-start;
}
#content{
display: flex;
width: 100%;
height: 400px;
justify-content: space-between;
}
#picture{
width: 55%;
display: flex;
align-items: center;
}
#picture img{
max-width: 90%;
max-height: 365px
}
#histograms{
width: 40%;
}
.mb-10{
margin-bottom: 10px;
}



</style>
